import { APIScopeData, ArdoqId, QueryBuilderQuery } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const closeAllOpenData = actionCreator(
  '[component hierarchies] CLOSE_ALL_OPEN_DATA'
);

export const closeWorkspace = actionCreator<{ workspaceId: string }>(
  '[component hierarchies] CLOSE_WORKSPACE'
);

export const hierarchiesWorkspaceIdsChanged = actionCreator<string[]>(
  '[component hierarchies] HIERARCHIES_WORKSPACE_IDS_CHANGED'
);

export const loadAdvancedSearchSucceeded = actionCreator<APIScopeData>(
  '[component hierarchies] LOAD_ADVANCED_SEARCH_SUCCEEDED'
);

export const selectFirstSelectableComponentInComponentHierarchy = actionCreator(
  '[component hierarchies] SELECT_FIRST_SELECTABLE_COMPONENT_IN_COMPONENT_HIERARCHY'
);

export const setComponentSelectQuery = actionCreator<{
  query: QueryBuilderQuery | null;
}>('[component hierarchies] SET_COMPONENT_SELECT_QUERY');

export type SetParentSelectQueryPayload = {
  workspaceQuery: QueryBuilderQuery;
  componentIds: string[];
};

export const setParentSelectQuery = actionCreator<SetParentSelectQueryPayload>(
  '[component hierarchies] SET_PARENT_SELECT_QUERY'
);

export const treeScrollHeightChanged = actionCreator<{ scrollHeight: number }>(
  '[component hierarchies] TREE_SCROLL_HEIGHT_CHANGED'
);

export const newItemHovered = actionCreator<{ nodeId: string }>(
  '[component hierarchies] NEW_ITEM_HOVERED'
);

export const selectComponentSelectionChanged = actionCreator<APIScopeData>(
  '[component hierarchies] SELECT_COMPONENT_SELECTION_CHANGED'
);

export type ParentSelectedPayload = {
  parentId: ArdoqId;
  parentName: string;
} | null;

export const parentSelected = actionCreator<ParentSelectedPayload>(
  '[component hierarchies] PARENT_SELECTED'
);
